import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Modal.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "transition",
    { attrs: { name: "modal", appear: "" } },
    [
      _c(
        "Blanket",
        { staticClass: "dialog", attrs: { "z-index": _vm.zIndex } },
        [
          _c("PositionerAbsolute", { attrs: { width: _vm.width } }, [
            _c(
              "form",
              {
                staticClass: "modal-container",
                attrs: { novalidate: "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault();
                    return _vm.onSubmit($event)
                  }
                }
              },
              [
                _vm._t("default", [
                  _c(
                    "header",
                    [
                      _vm._t("header", [
                        _c("Header", {
                          attrs: {
                            heading: _vm.heading,
                            appearance: _vm.appearance
                          }
                        })
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [_vm._t("content")], 2),
                  _vm._v(" "),
                  _c(
                    "footer",
                    [
                      _vm._t("footer", [
                        _vm._t("progress"),
                        _vm._v(" "),
                        _c("Footer", {
                          attrs: {
                            actions: _vm.actions,
                            "auto-focus": _vm.autoFocus,
                            appearance: _vm.appearance,
                            "should-allow-submit": _vm.shouldAllowSubmit,
                            pending: _vm.pending
                          },
                          on: { cancel: _vm.onCancel }
                        })
                      ])
                    ],
                    2
                  )
                ])
              ],
              2
            )
          ])
        ],
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-b471dad0";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Modal/Modal.vue.js